import OverViewIcon from "../Icons/OverViewIcon";
import { Outlet } from "react-router-dom";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RunsheetIcon from "../Icons/RunsheetIcon";
import OverViewVG from "../Icons/svgComponent/ContactSVG";
import DashboardSVG from "../Icons/svgComponent/DashboardSVG";
import StaffIcon from "../Icons/StaffIcon";
import ShiftIcon from "../Icons/ShiftIcon";

export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      {
        name: "Overview",
        href: "/human-resource-management",
        icon: DashboardSVG,
        activeIcon: OverViewIcon,
      },
    ],
  },
  {
    name: "Recruitment",
    href: "",
    icon: "",
    children: [
      {
        name: "OverView",
        href: "/human-resource-management/requitment",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
    ],
  },
  {
    name: "Onboarding",
    href: "",
    icon: "",
    children: [
      {
        name: "OverView",
        href: "/human-resource-management/contact",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
    ],
  },
  {
    name: "Employee",
    href: "",
    icon: "",
    children: [
      {
        name: "Staff",
        href: "/human-resource-management/employee/staff",
        icon: StaffIcon,
        activeIcon: StaffIcon,
      },
    ],
  },
  {
    name: "Attendance",
    href: "",
    icon: "",
    children: [
      {
        name: "Shift",
        href: "/human-resource-management/shift",
        icon: ShiftIcon,
        activeIcon: RunsheetIcon,
      },
      {
        name: "Report",
        href: "/human-resource-management/attendance/report",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
      {
        name: "Leave Application",
        href: "/human-resource-management/attendance/leave",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
    ],
  },
  {
    name: "Payroll",
    href: "",
    icon: "",
    children: [
      {
        name: "OverView",
        href: "/human-resource-management/contact",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
    ],
  },
  {
    name: "Performance",
    href: "",
    icon: "",
    children: [
      {
        name: "OverView",
        href: "/human-resource-management/contact",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
    ],
  },
  {
    name: "Offboarding",
    href: "",
    icon: "",
    children: [
      {
        name: "OverView",
        href: "/human-resource-management/contact",
        icon: OverViewVG,
        activeIcon: RunsheetIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
